import { render, staticRenderFns } from "./UserFormDialog.vue?vue&type=template&id=8d2e4e70&scoped=true&"
import script from "./UserFormDialog.vue?vue&type=script&lang=ts&"
export * from "./UserFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserFormDialog.vue?vue&type=style&index=0&id=8d2e4e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2e4e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VRow,VSnackbar,VTextField})
